import { ValueTypesSection } from 'App/data-export/components/DataExport/DataExportModalDrawer/components/ValueTypesSelect/components/ValueTypesSection'
import { InputWrapper } from 'App/data-export/components/DataExport/InputWrapper'
import { dataExportStore } from 'App/data-export/store/dataExportStore'
import type { getValueTypesForFieldAssetIdsWithPropertyId } from 'App/data-export/store/selectors/_utils/getValueTypesForFieldAssetIdsWithPropertyId'
import type { TDataExportValueTypesTimeseriesSection } from 'App/data-export/types/from-code-gen/TDataExportValueTypesTimeseriesSection'
import { sortSections } from 'App/Map/LayerNav/Layers/generateNavigationMenu/generateNavigationMenu'
import { translate } from 'i18n/i18n'
import { groupBy } from 'lodash'
import React, { useCallback } from 'react'
import type { TSection } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'

const dataExportSectionToSectionMap: Record<TDataExportValueTypesTimeseriesSection, TSection> = {
  weather: 'environment',
  water_management: 'water-management',
  pests: 'insects',
  diseases: 'diseases',
  crop_development: 'crop-development',
}

export const ValueTypesSelect = (props: {
  allowSectionToggle: boolean
  allowGroupToggle: boolean
  options: ReturnType<typeof getValueTypesForFieldAssetIdsWithPropertyId>
}) => {
  const state = dataExportStore.useSelector((s) => s)

  const entryValuesGroupedBySection = Object.values(groupBy(props.options, (x) => x.section)).sort((a, b) =>
    sortSections(
      dataExportSectionToSectionMap[a[0].section as TDataExportValueTypesTimeseriesSection],
      dataExportSectionToSectionMap[b[0].section as TDataExportValueTypesTimeseriesSection],
    ),
  )

  const toggleValueTypes = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const valueTypes = event.target.value.split(',')
    const selectedValueTypes = new Set(dataExportStore.getState().formState.valueTypes)

    if (event.target.checked) {
      valueTypes.forEach((valueType) => selectedValueTypes.add(valueType))
    } else {
      valueTypes.forEach((valueType) => selectedValueTypes.delete(valueType))
    }

    dataExportStore.actions.changeValueTypes([...selectedValueTypes])
  }, [])

  return (
    <InputWrapper
      label={translate.phrases.banyanApp('Select Value Types')}
      description={translate.phrases.banyanApp('Please select all the value types for export')}
      error={!!state.formErrors.valueTypes}
    >
      <div css={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        {entryValuesGroupedBySection.map((valueTypesForSection) => {
          const { section, sectionLabel } = valueTypesForSection[0]

          if (section === 'pests') {
            return (
              <ValueTypesSection
                key={section}
                allowGroupToggle={props.allowGroupToggle}
                allowSectionToggle={props.allowSectionToggle}
                sectionLabel={sectionLabel}
                selectedValueTypes={state.formState.valueTypes}
                toggleValueTypes={toggleValueTypes}
                valueTypesForSection={valueTypesForSection}
                valueTypesGroupByKey={'insectId'}
                valueTypesGroupByLabel={'insectLabel'}
                valueTypesGroupBySort={'insectLabel'}
              />
            )
          } else {
            return (
              <ValueTypesSection
                key={section}
                allowGroupToggle={props.allowGroupToggle}
                allowSectionToggle={props.allowSectionToggle}
                sectionLabel={sectionLabel}
                selectedValueTypes={state.formState.valueTypes}
                toggleValueTypes={toggleValueTypes}
                valueTypesForSection={valueTypesForSection}
                valueTypesGroupByKey={'valueGroup'}
                valueTypesGroupByLabel={'valueGroupLabel'}
                valueTypesGroupBySort={'valueGroupLabel'}
              />
            )
          }
        })}
      </div>
    </InputWrapper>
  )
}
